import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import { selectDeviceRoleModel } from 'selectors/entitySelector';
import { initializeDeviceRoleForm } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { saveDeviceRole } from 'actions/EntityActions';

class DeviceRoleSave extends Component {

    componentWillMount = () => {
        this.props.init();
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != null && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != null && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess){
                this.saveSuccess();
            }
            else if(newProps.deviceRoleName == ""){
                this.saveEmpty();
            }
            else{
                this.saveFailure();
            }
        }
    }

    saveRole = () => {
        this.props.save(this.props.roleModel);
        this.props.onCancel();
    }

    saveSuccess = () => {
        this.props.showSnackbar(LOOKUP.deviceRoles.saveMessage);

        if (this.props.onSave) {
            this.props.onSave();
        }
    }

    saveFailure = () => {
        this.props.showError(LOOKUP.deviceRoles.saveErrorMessage);
    }

    saveEmpty = () => {
        this.props.showError(LOOKUP.deviceRoles.saveEmptyMessage);
    }

    render() {
        const { name, onCancel } = this.props;

        return (
            <div style={{overflowY : "unset"}}>
                <div className="row">
                    <div className="col-lg-12">
                        <TextInput
                            name={`${name}Name`}
                            fullWidth={true}
                            label={LOOKUP.deviceRoles.name.label}
                            floatingLabelText={LOOKUP.deviceRoles.name.label}
                            hintText={LOOKUP.deviceRoles.name.hintText}
                            maxLength={20} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <Button
                            name="saveButton"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.product.controls.saveButton}
                            primary
                            onTouchTap={() => this.saveRole()} />
                        <Button
                            type="cancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.product.controls.cancelButton}
                            onTouchTap={() => onCancel()} />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatetoProps(state, props) {
    const { name } = props || {};

    return {
        roleModel: selectDeviceRoleModel(state, name),
        saveSuccess: state.form[`${name} SaveSuccess`],
        saveError: state.form[`${name}SaveError`],
        deviceRoleName: state.form.deviceSaveRoleName
    };
}

function mapDispatchToProps(dispatch, props) {
    const { name } = props || {};

    return {
        save: (model) => dispatch(saveDeviceRole(model, name)),
        init: () => dispatch(initializeDeviceRoleForm(name)),
        showError: (message) => dispatch(showError(message)),
        showSnackbar: (message) => dispatch(showSnackbar(message))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(DeviceRoleSave);